export default __webpack_public_path__ + "static/404-hero-c59095b00bb426c02f60abdec6636f12.png";